var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfilePic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4998 0.416992C10.3098 0.416992 0.416504 10.3103 0.416504 22.5003C0.416504 34.6903 10.3098 44.5837 22.4998 44.5837C34.6898 44.5837 44.5832 34.6903 44.5832 22.5003C44.5832 10.3103 34.6898 0.416992 22.4998 0.416992ZM11.6128 36.3687C12.5623 34.3812 18.3482 32.4378 22.4998 32.4378C26.6515 32.4378 32.4594 34.3812 33.3869 36.3687C30.3836 38.7537 26.6073 40.167 22.4998 40.167C18.3923 40.167 14.6161 38.7537 11.6128 36.3687ZM36.5448 33.1666C33.3869 29.3241 25.724 28.0212 22.4998 28.0212C19.2757 28.0212 11.6128 29.3241 8.45484 33.1666C6.20234 30.2074 4.83317 26.5195 4.83317 22.5003C4.83317 12.7616 12.7611 4.83366 22.4998 4.83366C32.2386 4.83366 40.1665 12.7616 40.1665 22.5003C40.1665 26.5195 38.7973 30.2074 36.5448 33.1666ZM22.4998 9.25033C18.2157 9.25033 14.7707 12.6953 14.7707 16.9795C14.7707 21.2637 18.2157 24.7087 22.4998 24.7087C26.784 24.7087 30.229 21.2637 30.229 16.9795C30.229 12.6953 26.784 9.25033 22.4998 9.25033ZM22.4998 20.292C20.6669 20.292 19.1873 18.8124 19.1873 16.9795C19.1873 15.1466 20.6669 13.667 22.4998 13.667C24.3328 13.667 25.8123 15.1466 25.8123 16.9795C25.8123 18.8124 24.3328 20.292 22.4998 20.292Z",
    fill: "#2B5297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfilePic);
export default __webpack_public_path__ + "static/media/default-profilePic.50e9550e9dfe0cce42f3ad52e01f8027.svg";
export { ForwardRef as ReactComponent };